import { string, object } from "yup";
import i18next from "/app/src/locales/config";

export const newIntegrationSchema = object().shape({
  name: string().trim().required(i18next.t("translation:required")),
});
